import { render } from "./PageNotFoundPage.vue?vue&type=template&id=6ffc18c3"
const script = {}

import "./PageNotFoundPage.vue?vue&type=style&index=0&id=6ffc18c3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__